import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { TextboxControl } from "@/Common/Components/Inputs/TextboxControl";
import { BloodPressure } from "@/Patient/Models/MedicalSummary/BloodPressure";

interface IBloodPressureFieldProps {
    readonly?: boolean;
    bloodPressure: BloodPressure;
    isInvalid?: boolean;
    onBloodPressureChange: (bloodPressure: BloodPressure) => void;
    cssClassName?: string;
    cssClassNameInput?: string;
    style?: React.CSSProperties;
    onBlur?: (bloodPressure?: BloodPressure, e?) => void;
}

class BloodPressureField extends BaseReactComponent<IBloodPressureFieldProps> {
    public render(): JSX.Element {
        const {
            bloodPressure,
            onBloodPressureChange,
            readonly,
            cssClassName,
            isInvalid,
            cssClassNameInput,
            onBlur,
            style
        } = this.props;

        const separatorElement = (
            <div className="separator">
                {(!readonly || bloodPressure?.hasValue()) && "/"}
            </div>
        );

        if (readonly) {
            return (
                <div className={`blood-pressure ${cssClassName ?? ""}`} style={style}>
                    <span className={`field-text systolic ${isInvalid ? "invalid-vital-sign" : ""}`}>{`${bloodPressure?.systolic ?? ""}`}</span>
                    {separatorElement}
                    <span className={`field-text diastolic ${isInvalid ? "invalid-vital-sign" : ""}`}>{`${bloodPressure?.diastolic ?? ""}`}</span>
                </div>
            );
        }

        return (
            <div className={`blood-pressure ${cssClassName ?? ""}`} style={style}>
                <TextboxControl
                    className={`form-control systolic ${cssClassNameInput ?? ""} ${isInvalid ? "invalid-vital-sign" : ""}`}
                    value={bloodPressure?.systolic?.toString() ?? ""}
                    onChange={value => onBloodPressureChange(new BloodPressure({ ...bloodPressure, systolic: value && Number(value) }))}
                    onBlur={e => onBlur?.(bloodPressure, e)}
                    IsNumeric={true}
                    maxLength={3}
                />
                {separatorElement}
                <TextboxControl
                    className={`form-control diastolic ${cssClassNameInput ?? ""} ${isInvalid ? "invalid-vital-sign" : ""}`}
                    value={bloodPressure?.diastolic?.toString() ?? ""}
                    onChange={value => onBloodPressureChange(new BloodPressure({ ...bloodPressure, diastolic: value && Number(value) }))}
                    onBlur={e => onBlur?.(bloodPressure, e)}
                    IsNumeric={true}
                    maxLength={3}
                />
            </div>
        );
    }
}

export { BloodPressureField };
